import ChannelInfoSettings from "discourse/plugins/chat/discourse/components/chat/routes/channel-info-settings";

export default <template>
  <ChannelInfoSettings @channel={{@controller.model}} />
</template>
